export const SCRIPT_BUNDLE =
  'https://www.google.com/recaptcha/enterprise.js?render=$RECAPTCHA_SITE_KEY';
